import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import Cookies from 'js-cookie';

import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);


function FoodPantryDashboard({ contentOpen, setContentOpen }) {
  // Organization state management
  const [organization, setOrganization] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [selectedOrgID, setSelectedOrgID] = useState("");
  const [showOrgSelector, setShowOrgSelector] = useState(true);
  const [isRootUser, setIsRootUser] = useState(false);

  // Handle organization selection
  const handleSelectedOrgID = (orgName) => {
    const matchedOrg = organization.find(org => org.name === orgName);
    if (matchedOrg) {
      setSelectedOrgID(matchedOrg.orgID);
    } else {
      setSelectedOrgID(null);
      console.error("Organization ID not found for the selected organization.");
    }
  };

  const handleOrgChange = (e) => {
    // Only root users can change organizations
    if (isRootUser) {
      const selectedName = e.target.value;
      setSelectedOrg(selectedName);
      handleSelectedOrgID(selectedName);
    }
  };

  // Fetch organizations list
  useEffect(() => {
    const checkUserRoleAndFetchOrganizations = async () => {
      try {
        const sessionID = Cookies.get('sessionID');
        if (!sessionID) {
          console.error("Session ID not found");
          return;
        }

        // Check user role
        const roleResponse = await fetch(process.env.REACT_APP_BACKURL + '/api/foodPantry/user/role', {
          headers: {
            'Authorization': `Bearer ${sessionID}`,
          },
          credentials: 'include',
        });

        if (!roleResponse.ok) {
          throw new Error(`Role check error! Status: ${roleResponse.status}`);
        }

        const roleData = await roleResponse.json();
        const { roleID } = roleData;

        if (roleID === "0") {
          // Root user - fetch all organizations
          setIsRootUser(true);
          const orgResponse = await fetch(process.env.REACT_APP_BACKURL + '/api/foodPantry/organization', {
            credentials: 'include',
          });
          if (!orgResponse.ok) throw new Error(`Organization error! Status: ${orgResponse.status}`);

          const orgData = await orgResponse.json();
          if (orgData?.OrgNames?.length) {
            setOrganization(orgData.OrgNames);
          }
        } else {
          // Non-root user - fetch only their organization
          setIsRootUser(false);
          let cookieOrgID = Cookies.get('OrgID');
          
          // Parse JSON-encoded cookie if necessary
          if (cookieOrgID && cookieOrgID.startsWith('j:')) {
            try {
              const parsed = JSON.parse(cookieOrgID.slice(2));
              // Handle both array and object formats
              if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].orgID) {
                cookieOrgID = parsed[0].orgID;
              } else if (typeof parsed === 'string' && parsed !== 'null') {
                cookieOrgID = parsed;
              } else {
                cookieOrgID = null;
              }
            } catch (err) {
              console.error("Error parsing OrgID cookie:", err);
              cookieOrgID = null;
            }
          }
          
          // Only proceed if we have a valid orgID
          if (cookieOrgID && cookieOrgID !== 'null') {
            try {
              const orgResponse = await fetch(process.env.REACT_APP_BACKURL + `/api/foodPantry/organization/${cookieOrgID}`, {
                credentials: 'include',
              });
              if (!orgResponse.ok) throw new Error(`Organization error! Status: ${orgResponse.status}`);

              const orgData = await orgResponse.json();
              if (orgData?.organization) {
                const orgObj = {
                  orgID: cookieOrgID,
                  name: orgData.organization.organizationName
                };
                setOrganization([orgObj]);
                setSelectedOrg(orgData.organization.organizationName);
                setSelectedOrgID(cookieOrgID);
              }
            } catch (err) {
              console.error('Error fetching organization data:', err);
            }
          } else {
            console.error('No valid OrgID found in cookie');
          }
        }
      } catch (error) {
        console.error('Error checking user role or fetching organizations:', error);
      }
    };
    checkUserRoleAndFetchOrganizations();
  }, []);

   // Parse OrgID from cookie
   useEffect(() => {
  let cookieOrgID = Cookies.get('OrgID');
  
    // 2. Add URL decoding here to handle %3A, %5B, %22, etc.
    if (cookieOrgID) {
      cookieOrgID = decodeURIComponent(cookieOrgID);
    }

    if (cookieOrgID && cookieOrgID.startsWith('j:')) {
      try {
        const orgArr = JSON.parse(cookieOrgID.slice(2));
        if (Array.isArray(orgArr) && orgArr.length > 0 && orgArr[0].orgID) {
          cookieOrgID = orgArr[0].orgID;
        } else {
          cookieOrgID = null;
        }
      } catch (err) {
        console.error("Error parsing OrgID cookie:", err);
        cookieOrgID = null;
      }
    }
    if (cookieOrgID) {
      setSelectedOrgID(cookieOrgID);
      setShowOrgSelector(false);
      if (organization && organization.length > 0) {
        const matchedOrg = organization.find(org => org.orgID === cookieOrgID);
        if (matchedOrg) {
          setSelectedOrg(matchedOrg.name);
        }
      }
    } else {
      setShowOrgSelector(true);
    }
  }, [organization]);
  
  
    const [clientId, setClientId] = useState('client1');
    const [numResults, setNumResults] = useState(10);
    const [startDate, setStartDate] = useState('2025-01-01'); // Start of year
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]); // Today
  const [dashboardStats, setDashboardStats] = useState({
    amountDistributed: 0,
    householdsServed: 0,
    distributionEvents: 0,
  });

  const [topTenDonors, setTopTenDonors] = useState([]);
  const [clientAgeRange, setClientAgeRange] = useState([]);

  const baseAPIurl = window.baseAPIurl || process.env.REACT_APP_BACKURL || "";

  useEffect(() => {
    if (!selectedOrgID) return;

    // 2) Fetch stats
    fetch(baseAPIurl + `/api/foodPantry/reports/${selectedOrgID}/getYearlyStats?startDate=${startDate}&endDate=${endDate}`, { credentials: "include" })
      .then((res) => (res.ok ? res.json() : Promise.reject(res)))
      .then((data) => {
        setDashboardStats({
          amountDistributed: data.totalAmountDistributed ?? 0,
          householdsServed: data.totalClientsServed ?? 0,
          distributionEvents: data.totalDonationsReceived ?? 0,
        });
        setTopTenDonors(Array.isArray(data.topTenDonors) ? data.topTenDonors : []);
        setClientAgeRange(Array.isArray(data.clientAgeRange) ? data.clientAgeRange : []);
      })
      .catch((err) => {
        console.error('Error fetching yearly stats:', err);
        // fallback demo data so the UI still renders
        setDashboardStats({ amountDistributed: 0, householdsServed: 0, distributionEvents: 0 });
        setTopTenDonors([]);
        setClientAgeRange([]);
      });
  }, [baseAPIurl, selectedOrgID, startDate, endDate]);

  const pieData = useMemo(
    () => ({
      labels: clientAgeRange.map(item => item.ageGroup),
      datasets: [
        {
          data: clientAgeRange.map(item => item.count),
          backgroundColor: ["#007bff", "#28a745", "#17a2b8", "#ffc107", "#6f42c1", "#dc3545", "#fd7e14", "#20c997", "#6610f2"],
        },
      ],
    }),
    [clientAgeRange]
  );

  return (
    <div className="card col-12 col-md-10 offset-0 offset-md-1 mt-5 card-body container my-3">
      {/* Header */}
      <div className="card-header d-flex justify-content-between align-items-center pb-3 flex-wrap gap-2">
        <h3 className="mb-0">
          <i className="bi bi-bar-chart pe-3"></i>
          <span>Inventory Dashboard</span>
        </h3>
        {isRootUser ? (
          <select
            id="organization-select"
            className="form-select w-auto"
            value={selectedOrg}
            onChange={handleOrgChange}
            required
          >
            <option value="" disabled>Select Organization</option>
            {organization && organization.length > 0 && organization.map((org, index) => (
              <option key={index} value={org.name || ''}>
                {org.name || 'Unknown Organization'}
              </option>
            ))}
          </select>
        ) : (
          <div className="d-flex align-items-center p-2 rounded border bg-light">
            <h5 className="mb-0">
              <span className="fw-bold">Organization:</span> {selectedOrg}
            </h5>
          </div>
        )}
      </div>

      {/* Stat cards */}
      <div className="row mb-4 mt-4">
        <div className="col-md-4 mb-3">
          <div className="card shadow-sm h-100">
            <div className="card-body text-center">
              <h6 className="text-muted">Amount Distributed YTD</h6>
              <h2 className="fw-bold text-primary">
                ${dashboardStats.amountDistributed?.toLocaleString() ?? 0}
              </h2>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="card shadow-sm h-100">
            <div className="card-body text-center">
              <h6 className="text-muted">Total Clients Served YTD</h6>
              <h2 className="fw-bold text-success">
                {dashboardStats.householdsServed?.toLocaleString() ?? 0}
              </h2>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="card shadow-sm h-100">
            <div className="card-body text-center">
              <h6 className="text-muted">Number of Donations YTD</h6>
              <h2 className="fw-bold text-info">
                {dashboardStats.distributionEvents?.toLocaleString() ?? 0}
              </h2>
            </div>
          </div>
        </div>
      </div>

      {/* Upcoming + Chart */}
      <div className="row">
        <div className="col-lg-6 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-white">
              <h6 className="mb-0">Top 10 Donors</h6>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                {topTenDonors.length === 0 ? (
                  <li className="list-group-item text-muted">
                    No donor data available.
                  </li>
                ) : (
                  topTenDonors.map((donor, idx) => (
                    <li key={idx} className="list-group-item d-flex justify-content-between align-items-center py-3">
                      <span className="fs-5 fw-semibold">
                        {donor.firstName && donor.lastName 
                          ? `${donor.firstName} ${donor.lastName}`
                          : `Donor #${donor.donorID.substring(0, 8)}`}
                      </span>
                      <span className="badge bg-primary rounded-pill fs-5 px-3 py-2">
                        ${Number(donor.totalDonatedValue).toFixed(2)}
                      </span>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </div>

        <div className="col-lg-6 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-white">
              <h6 className="mb-0">Approximate Age Distribution for Clients</h6>
            </div>
            <div className="card-body d-flex justify-content-center align-items-center">
              {clientAgeRange.length > 0 ? (
                <Pie data={pieData} />
              ) : (
                <div className="text-muted">No age distribution data available</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
 
}

export default FoodPantryDashboard;
